<template>
  <WhiteModal
    :title="$t('modificators_merge_modal.title')"
    @close="$emit('close')"
    hideFooter
  >
    <div class="deps-table">
      <div class="gap-column-xs">
        <div class="qrw-label-sm qrw-text-content-base-tertiary w-100">
          {{ $t("modificators_settings.group") }}
        </div>
        <div class="fake-del-btn"></div>
      </div>
      <BaseDivider color="border-base-tertiary" />
      <div
        class="dep-row gap-column-xs"
        v-for="g in allGroupsDependentOnItem"
        :key="g._id"
      >
        <div class="qrw-label-md bold qrw-text-content-base-primary w-100">
          {{ g.name }}
        </div>
        <BaseIconButton
          icon="x"
          size="sm"
          variant="outlined"
          textColor="content-error-primary"
          borderColor="border-error-secondary"
          borderHoverColor="border-error-primary"
          @click="removeDependency(g)"
        />
      </div>
      <BaseDivider color="border-base-tertiary" v-if="allGroupsDependentOnItem.length"/>
      <div class="dep-row gap-column-xs">
        <BaseSelect
          class="w-100"
          v-model="selectedGroupId"
          :placeholder="$t('modificators_merge_modal.group_ph')"
        >
          <option :value="null" disabled>
            {{ $t("modificators_merge_modal.group_ph") }}
          </option>
          <option
            v-for="(v, k) in availableGroupsToDependOn"
            :key="k"
            :value="v._id"
          >
            {{ v.name }}
          </option>
        </BaseSelect>
        <BaseIconButton
          icon="plus"
          @click="addDependency"
          :disabled="!selectedGroupId"
          size="sm"
          variant="outlined"
          textColor="content-base-primary"
          borderColor="border-base-secondary"
          borderHoverColor="border-base-primary"
        />
      </div>
    </div>
  </WhiteModal>
</template>

<script>
export default {
  props: {
    itemId: String,
  },
  data() {
    return {
      selectedGroupId: null,
      selectedItemId: null,
    };
  },
  methods: {
    addDependency() {
      const group = this.dish.price_groups.find(g => g._id == this.selectedGroupId);

      if (!group) return;

      this.$store.commit("menu/setPriceGroupData", {
        id: group._id,
        key: "show_for",
        value: [...(group.show_for || []), this.itemId],
      });
      this.$store.dispatch("menu/updateProduct");

      this.selectedGroupId = null;
      this.selectedItemId = null;
    },
    removeDependency(group) {
      this.$store.commit("menu/setPriceGroupData", {
        id: group._id,
        key: "show_for",
        value: (group.show_for || []).filter(
          (id) => id != this.itemId
        ),
      });
      this.$store.dispatch("menu/updateProduct");
    },
    getNamesForItemId(id) {
      const result = this.allDishPriceGroupItemsWithGroupNames.find(
        (item) => item._id == id
      ) || {
        name: `n/a (${id})`,
        group_name: "n/a",
      };

      return result;
    },
  },
  computed: {
    dish() {
      return this.$store.state.menu.product;
    },
    allGroupsDependentOnItem() {
      return this.dish.price_groups.filter(
        (pg) => pg.show_for && pg.show_for.includes(this.itemId)
      );
    },
    availableGroupsToDependOn() {
      return this.dish.price_groups.filter(
        (pg) => this.allGroupsDependentOnItem.indexOf(pg) == -1
      );
    },
  },
};
</script>

<style scoped>
.deps-table {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.dep-row {
  align-items: center;
}

.fake-del-btn {
  width: 32px;
  background: transparent;
  height: 16px;
  min-width: 32px;
}
</style>
